import { __read } from "tslib";
import Handlebars from 'handlebars';
import React, { useMemo, useState } from 'react';
import { LoadingIcon } from '../LoadingIcon/LoadingIcon';
import { MarkdownViewer } from '../Markdown/MarkdownViewer';
export var HandlebarsViewer = function (_a) {
    var templateSource = _a.templateSource, data = _a.data;
    var _b = __read(useState(''), 2), renderedTemplate = _b[0], setRenderedTemplate = _b[1];
    useMemo(function () {
        var template = Handlebars.compile(templateSource);
        var result = template(data);
        setRenderedTemplate(result);
    }, [templateSource, data]);
    if (renderedTemplate) {
        return React.createElement(MarkdownViewer, { allowDangerousHtml: true }, renderedTemplate);
    }
    else {
        return React.createElement(LoadingIcon, null);
    }
};
//# sourceMappingURL=HandlebarsViewer.js.map